export default {
    Strengths: 'strengths',
    Needs: 'needs',
    Goals: 'goals',
    SubAreas: 'subareas',
    Procedures: 'procedures',
    ResultSummary: 'resultsummary'
}